// extracted by mini-css-extract-plugin
module.exports = {"cover":"styles_cover__3ttTi","imageContainer":"styles_imageContainer__3Yn_s","info":"styles_info__1MvZK","username":"styles_username__JaKoS","title":"styles_title__2mRi1"};